import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ReactHtmlParser from 'react-html-parser';
import dompurify from 'dompurify';

import {
    fetchListOfAppointments,
    sendAppointmentRequest,
} from 'src/shared_modules/veu-visitors-core/actions/appointments';

import {
    fetchToken,
    validateToken
} from 'src/shared_modules/veu-visitors-core/actions/token';

import {
    showStaticContent
} from "src/shared_modules/veu-visitors-core/actions/content";

import {
    Translate,
    currentLanguage,
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

//import moment from 'moment';
import moment from 'moment-timezone';

import {
    formOfAdressCodeToI18nValue
} from 'src/shared_modules/veu-visitors-core/components/common/foa-select';

import FormControl, { initFieldState } from "src/shared_modules/veu-visitors-core/components/common/formControl";
import TokenValidationComponent from "src/shared_modules/veu-visitors-core/components/common/token-validation";
import MarketingConsentButton from "src/shared_modules/veu-visitors-core/components/common/marketingConsentButton";

import Alert from '@material-ui/lab/Alert';

import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';

import {
    Grid,
    Button,
    Backdrop,
    CircularProgress,
} from '@material-ui/core';

import 'src/shared_modules/veu-visitors-core/components/popovers/popovers.css';
import './appointments.css';


class ComponentAppointments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading : true,
            isSuccess: false,
            isValidate: false,
            canSend: false,
            validateFailed: false,
            isBusy: false,
            failed: false,
            fields: {
            },
            fieldErrors : {
            },
        }

        this.handleValidateToken= this.handleValidateToken.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.registerAppointment = this.registerAppointment.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleSelectAppointment = this.handleSelectAppointment.bind(this);
        this.renderAppointmentContainer = this.renderAppointmentContainer.bind(this);
        this.handleRegisterAppointment = this.handleRegisterAppointment.bind(this);

        this.initFormControls = this.initFormControls.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.handleFormControlChange = this.handleFormControlChange.bind(this);

    }

    async componentDidMount() {
        const { compRef } = this.props;
        compRef(this);

        if( this.props.appointments && this.props.appointments.identifier ) {
            //console.log("ComponentAppointments - this.props.appointment.identifier: " + this.props.appointments.identifier);
            await this.props.fetchListOfAppointments(this.props.appointments.identifier);
        }

        if( this.props.appointments.list.appointmentList.appointments.length === 1 ) {
            // preset appointment if there is only one
            let app = this.props.appointments.list.appointmentList.appointments[0];
            this.setState({
                selectedAppointment: app
            })
        }

        this.initFormControls();

        this.setState({isLoading: false});

        //console.log("trackEvent - Communication - show - RequestList-" + this.props.appointments.list.appointmentList.title.en);
        this.props.trackEvent("Communication", "show", "RequestList-" + this.props.appointments.list.appointmentList.title.en);
    }

    componentWillUnmount() {
        const { compRef } = this.props;
        compRef(undefined);
    }

    handleClose() {
        this.setState({
            isLoading : true,
            isSuccess: false,
            isValidate: false,
            canSend : false,
            validateFailed: false,
            isBusy: false,
            failed: false,
            selectedAppointment: null,
            fields: {
            },
            fieldErrors : {
            },
        });

        this.props.hidePopover("Appointments");

        //console.log("trackEvent - Communication - hide - RequestList-" + this.props.appointments.list.appointmentList.title.en);
        this.props.trackEvent("Communication", "hide", "RequestList-" + this.props.appointments.list.appointmentList.title.en);
    }

    initFormControls() {
        let appointmentList = this.props.appointments.list.appointmentList;

        if( appointmentList.formControls && appointmentList.formControls.id && appointmentList.formControls.elements.length > 0 ) {
            // pre set the formId as hidden field
            let fields = this.state.fields;
            fields.formId = appointmentList.formControls.id;
            // selected appointment needs also be stored into form data
            fields.selectedAppointment = null;
            if( this.state.selectedAppointment ) {
                fields.selectedAppointment = this.state.selectedAppointment._id;
            }

            for( let i=0; i< appointmentList.formControls.elements.length; i++ ) {
                let ele = appointmentList.formControls.elements[i];
                let val = initFieldState( ele, this.props.user);
                if( val !== null )
                    fields[ele.name] = val;
            }
            this.setState({
                fields:  fields,
                canSend: this.validateFields()
            });
        }
    }

    validateInput(fc) {
        let value = this.state.fields[fc.name];

        if( value === undefined || value === null )
            return false;

        if( fc.valueType === "checkbox" && value === false)
            return false;

        if( fc.valueType !== "checkbox" && value.trim() === "")
            return false;

        return true;
    }

    validateFields() {
        let fc = this.props.appointments.list.appointmentList.formControls.elements;
        for( let i=0; i<fc.length; i++ ) {
            if( fc[i].isMandatory ) {
                if( !this.validateInput(fc[i]) )
                    return false;
            }
        }
        return true;
    }

    handleFormControlChange( e, fieldname, value ) {
        let fields = this.state.fields;
        fields[fieldname] = value;

        let canSend = this.validateFields();

        this.setState({
                fields : fields,
                canSend : canSend,
                fieldErrors: {},
            });
    }

    handleReset(event) {
        this.setState({
            isSuccess: false,
            isValidate: false,
            canSend : false,
            //canValidate: false,
            validateFailed: false,
            isBusy: false,
            selectedAppointment: null,
            fields: {
            },
            fieldErrors : {
            },
        });

        this.initFormControls();
    }

    handleSelectAppointment(appointment) {
        if (!this.props.isProtected || (this.props.user && this.props.user.loggedIn  && this.props.event.hasPlazzConvention)) {
            let fields = this.state.fields;
            if( appointment !== null )
                fields.selectedAppointment = appointment._id;

            this.setState({
                fields: fields,
                selectedAppointment: appointment,
            });

            if( appointment !== null ) {
              //console.log("trackEvent - Communication - click - Request-" + appointment.title.en);
              this.props.trackEvent("Communication", "click", "Request-" + appointment.title.en );
            }
        }
    }

    handleRegisterAppointment() {
        let fields = this.state.fields;
        if( fields.formOfAdress )
            fields.formOfAdress = formOfAdressCodeToI18nValue(fields.formOfAdress);

        let currentLangi18n = currentLanguage();

        if( this.props.user && this.props.user.loggedIn  && this.props.event.hasPlazzConvention) {
            //console.log("handleSelectAppointment loggedin");
            this.registerAppointment();
        } else {
            // user not logged in we need a verification
            this.props.fetchToken(this.state.fields["email"], currentLangi18n.code2, fields);
            this.setState({
                isValidate: true
            });
        }
    }

    async handleValidateToken(code) {
        if (this.state.isBusy)
            return;

        this.setState({
            isBusy: true,
        });

        await this.props.validateToken(this.props.token.tokenId, code);

        this.setState({
            isBusy: false,
        });

        if (this.props.token.isTokenValid) {
            this.setState({
                isValidate: false,
                validateFailed: false,
            });
            this.registerAppointment();
        } else {
            this.setState({
                isValidate: true,
                validateFailed: true,
            });
        }
    }

    async registerAppointment() {
        if( !this.state.canSend || this.state.isBusy )
            return;

        if( !this.state.selectedAppointment )
            return;

        this.setState({ isBusy: true });

        let fields = this.state.fields;
        // user logged in no need for token verification
        if( fields.formOfAdress )
            fields.formOfAdress = formOfAdressCodeToI18nValue(fields.formOfAdress);

        await this.props.sendAppointmentRequest(fields);

        this.setState({
            isBusy: false,
            isSuccess: true
        });

        //console.log("trackEvent - Communication - send - Request-" + this.state.selectedAppointment.title.en);
        this.props.trackEvent("Communication", "send", "Request-" + this.state.selectedAppointment.title.en);
    }

    renderAppointmentContainer(app, lang, isListItem, key, sanitizer) {
      //let dateFormat = t("moment.date") + ", " + t("moment.time");

      return <div className={isListItem ? "appointmentItemContainer" : "appointmentContainer"} key={key}>
                <div className="appointmentItemUpperFlexContainer">
                    <div className="appointmentItemContainerLeft">
                        {(app.title[lang.code2] && app.title[lang.code2] !== "") && <h2 className="appointmentTitle">{app.title[lang.code2]}</h2>}
                    </div>
                    <div className="appointmentItemContainerRight">
                        <div className="appointmentDateContainer">
                            {(app.date && app.date !== "") && !this.props.appointments.list.appointmentList.isInfo &&
                              <h2 className="appointmentDate">{moment(app.date).locale(lang.locale).local().format("L, LT")} <Translate>popovers.appointments.clock</Translate></h2>
                            }
                        </div>
                    </div>
                </div>
                <div className="appointmentItemContainerMiddle">
                    {(app.description[lang.code2] && app.description[lang.code2] !== "") && <div className="appointmentDescription">{ReactHtmlParser(sanitizer(app.description[lang.code2]))}</div>}
                </div>
                <div className="appointmentItemUpperLowerContainer">
                    <div className="appointmentItemContainerLeft">
                        {!this.props.appointments.list.appointmentList.isInfo &&
                          <div className="appointmentFooter">{(app.advisor && app.advisor !== "") && <span>{app.advisor}</span>}
                                                             {(app.advisor && app.advisor !== "" && app.language[lang.code2] && app.language[lang.code2] !== "") && <span> | </span>}
                                                             {(app.language[lang.code2] && app.language[lang.code2] !== "") && <span>{app.language[lang.code2]}</span>}
                          </div>
                        }
                    </div>
                    <div className="appointmentItemContainerRight">
                        {!isListItem ? ((!this.state.isSuccess && this.props.appointments.list.appointmentList.appointments.length > 1) &&
                                      <div className="appointmentSelectButtonContainer">
                                        <span className="appointmentSelectButton" onClick={()=>{this.handleSelectAppointment(null)}}><Translate>popovers.appointments.change</Translate></span>
                                      </div>)
                                    : <div className="appointmentSelectButtonContainer">
                                        <span className={(this.props.isProtected && (!this.props.user || !this.props.user.loggedIn || !this.props.event.hasPlazzConvention)) ? "appointmentSelectButton appointmentSelectButton--disabled"
                                                                                                         : "appointmentSelectButton"} onClick={()=>{this.handleSelectAppointment(app)}}>
                                          <Translate>popovers.appointments.register</Translate>
                                        </span>
                                      </div>
                        }
                    </div>
                </div>
             </div>;
    }


    renderListView (lang, sanitizer){
        //The list ist already sorted from backend
        let sortedAppointment = this.props.appointments.list.appointmentList.appointments;
        let appointmentList = sortedAppointment.map((app, i) => {
            return this.renderAppointmentContainer(app, lang, true, i, sanitizer);
        });

        return <React.Fragment>
                <h1>{this.props.appointments.list.appointmentList.title[lang.code2]}</h1>
                    <div className="appointmentListContainer">
                        <div className="successAppointmentDescription">
                            {ReactHtmlParser(sanitizer(this.props.appointments.list.appointmentList.description[lang.code2]))}
                        </div>
                        {appointmentList}
                    </div>
             </React.Fragment>;
    }

    renderProfileView (appointmentList, lang, sanitizer) {
        let app = this.state.selectedAppointment;

        return (<React.Fragment>
                {this.renderAppointmentContainer(app, lang, false, 1, sanitizer)}

                <div className="profileAppointmentContainer">
                    <h2 className="profileHeadline"><Translate>popovers.appointments.profileHeadline</Translate></h2>
                    <Grid container spacing={3}>
                        {this.renderFormControls()}
                    </Grid>
                </div>
                {this.state.failed && <React.Fragment>
                    <Alert variant="outlined" severity="error" className="none-scroll">
                        <Translate>{this.state.error}</Translate>
                    </Alert>
                    <p></p>
                </React.Fragment> }
                <div className="appointmentDualButtonContainer">
                    <div className="appointmentButtonContainerLeft">
                        <MarketingConsentButton />
                    </div>
                    <div className="appointmentButtonContainerRight">
                        { this.props.appointments.list.appointmentList.appointments.length > 1 && <Button
                                color="primary"
                                onClick={() =>{ this.handleSelectAppointment(null); } }
                            >
                            <Translate>pano-controls.back</Translate>
                        </Button>}
                        <Button variant="contained"
                                color="secondary"
                                className="sendAppointmentButton"
                                onClick={()=>{this.handleRegisterAppointment();}}
                                disabled={!this.state.canSend}>
                            <Translate>popovers.appointments.finishAppointment</Translate>
                        </Button>
                    </div>
                </div>
            </React.Fragment>);
    }

    renderFormControl(control) {
        // handle the grid layout here (2 columns and 1 column )
        let lbl = "person-labels." + control.name;

        // 1 column cases
        if( control.valueType === "checkbox" || control.valueType === "messagebox" || control.valueType === "note" )
            return (<Grid item xs={12} sm={12}>
                        <FormControl def={control}
                            label={lbl}
                            value={this.state.fields[control.name]}
                            onChange={this.handleFormControlChange}
                            error={this.state.fieldErrors[control.name]}
                        />
                </Grid>);

        // rest is 2 columns
        return (<Grid item xs={12} sm={6}>
                    <FormControl def={control}
                        label={lbl}
                        value={this.state.fields[control.name]}
                        onChange={this.handleFormControlChange}
                        error={this.state.fieldErrors[control.name]}
                    />
            </Grid>);
    }

    renderFormControls() {
        // check if controls are set
        let appointmentList = this.props.appointments.list.appointmentList;
        if( !appointmentList.formControls
                || !appointmentList.formControls.id
                || !appointmentList.formControls.elements
                || appointmentList.formControls.elements.length === 0 )
            return( null );

        let fc = appointmentList.formControls.elements.map((control, index) => {
                return this.renderFormControl(control);
            });

        return(<React.Fragment>
                { fc }
            </React.Fragment>);
    }

    renderSuccessView(lang, sanitizer) {
        let app = this.state.selectedAppointment;
        return(<React.Fragment>
                 <h1><Translate>popovers.appointments.successAppointment</Translate></h1>
                 <p className="successAppointmentDescription"><Translate>popovers.appointments.successAppointmentDescription</Translate></p>
                 {this.renderAppointmentContainer(app, lang, false, 1, sanitizer)}
                 <div className="appointmentButtonContainer">
                    <Button variant="contained" color="secondary" className="finishAppointmentCloseButton" onClick={()=>{this.handleClose()}}>
                        <Translate>popovers.appointments.close</Translate>
                    </Button>
                 </div>
              </React.Fragment>);
    }

    render() {
        // while loading
        if( this.state.isLoading )
            return (<Backdrop className="inside-container" open={true} invisible={true}>
                            <CircularProgress color="secondary" />
                        </Backdrop>);

        // failsave
        if( !this.props.appointments.list
                || !this.props.appointments.list.appointmentList.appointments
                || this.props.appointments.list.appointmentList.appointments.length === 0) {
            return null;
        }

        const sanitizer = dompurify.sanitize;
        let currentLangi18n = currentLanguage();
        let isSelected = (this.state.selectedAppointment !== null && this.state.selectedAppointment !== undefined);

        return(<div className="appointmentsComponent">
                {!isSelected && this.renderListView(currentLangi18n, sanitizer) }
                {isSelected && this.state.isValidate && <TokenValidationComponent
                        isBusy={this.state.isBusy}
                        validate={(code)=>{this.handleValidateToken(code)}}
                        validateFailed={this.state.validateFailed }
                        trackingName="appointment"
                />}
                {isSelected && this.state.isSuccess &&
                        this.renderSuccessView(currentLangi18n, sanitizer)
                }
                {isSelected && !this.state.isSuccess && !this.state.isValidate &&
                        this.renderProfileView(this.props.appointments.list.appointmentList, currentLangi18n, sanitizer)
                }
            </div>);
    }
}

/*
 * ---------------------------------------------------------------------
 * prop Types
 * ---------------------------------------------------------------------
 */
ComponentAppointments.propTypes = {
    user : PropTypes.object,
    system : PropTypes.object,
    currentLang : PropTypes.string,
    appointments : PropTypes.object,
    visibleUserProfileFields: PropTypes.object,
    token : PropTypes.object,
    event : PropTypes.object,
};

/*
 * ---------------------------------------------------------------------
 * Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        user: state.user,
        system: state.system,
        currentLang : state.system.currentLang,
        appointments: state.appointments,
        token: state.token,
        event: state.event,
    };
};

const mapDispatchToProps = {
    fetchListOfAppointments,
    fetchToken,
    validateToken,
    sendAppointmentRequest,
    showStaticContent,
    showPopover,
    hidePopover
};
 /*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withMatomo(ComponentAppointments));
